module.exports = __webpack_public_path__ + "img/personage1.bca5d524.png";